import React from "react";
import Accordion from "./Accordion";

const FAQ = () => {
  return (
    <div className="max-lg:px-6">
      <div>
        <h1 className="head-text">Frequently Asked Questions</h1>
        <span className="text-center max-w-[500px] mx-auto text-paragraph">
          We’ve answered some questions here so you would not have to ask them
          again
        </span>
      </div>
      <div className="my-100">
        <Accordion title="Where can i watch?">
          <span>
            Nibh quisque suscipit fermentum netus nulla cras porttitor euismod
            nulla. Orci, dictumst nec aliquet id ullamcorper venenatis.{" "}
          </span>
        </Accordion>

        <Accordion title="Mauris id nibh eu fermentum mattis purus?">
          <span>
            Nibh quisque suscipit fermentum netus nulla cras porttitor euismod
            nulla. Orci, dictumst nec aliquet id ullamcorper venenatis.{" "}
          </span>
        </Accordion>
        <Accordion title="Mauris id nibh eu fermentum mattis purus?">
          <span>
            Nibh quisque suscipit fermentum netus nulla cras porttitor euismod
            nulla. Orci, dictumst nec aliquet id ullamcorper venenatis.{" "}
          </span>
        </Accordion>
        <Accordion title="Mauris id nibh eu fermentum mattis purus?">
          <span>
            Nibh quisque suscipit fermentum netus nulla cras porttitor euismod
            nulla. Orci, dictumst nec aliquet id ullamcorper venenatis.{" "}
          </span>
        </Accordion>

        <Accordion title="Mauris id nibh eu fermentum mattis purus?">
          <span>
            Nibh quisque suscipit fermentum netus nulla cras porttitor euismod
            nulla. Orci, dictumst nec aliquet id ullamcorper venenatis.{" "}
          </span>
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
